export const faqsData = [
  {
    id: 1,
    question: `What is Enterapp?`,
    answer: `  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
    Suscipit distinctio eaque amet delectus fugit nostrum aut
    debitis corrupti culpa. Asperiores eum dignissimos
    reiciendis quos cumque aspernatur quo voluptate qui
    laborum? Lorem ipsum dolor sit, amet consectetur
    adipisicing elit. Suscipit distinctio eaque amet delectus
    fugit nostrum aut debitis corrupti culpa. Asperiores eum
    dignissimos reiciendis quos cumque aspernatur quo
    voluptate qui laborum?`,
  },
  {
    id: 2,
    question: `How can I participate in the ICO?`,
    answer: `  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
    Suscipit distinctio eaque amet delectus fugit nostrum aut
    debitis corrupti culpa. Asperiores eum dignissimos
    reiciendis quos cumque aspernatur quo voluptate qui
    laborum? Lorem ipsum dolor sit, amet consectetur
    adipisicing elit. Suscipit distinctio eaque amet delectus
    fugit nostrum aut debitis corrupti culpa. Asperiores eum
    dignissimos reiciendis quos cumque aspernatur quo
    voluptate qui laborum?`,
  },
  {
    id: 3,
    question: `Can I use Enter App on multiple devices?`,
    answer: `  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
    Suscipit distinctio eaque amet delectus fugit nostrum aut
    debitis corrupti culpa. Asperiores eum dignissimos
    reiciendis quos cumque aspernatur quo voluptate qui
    laborum? Lorem ipsum dolor sit, amet consectetur
    adipisicing elit. Suscipit distinctio eaque amet delectus
    fugit nostrum aut debitis corrupti culpa. Asperiores eum
    dignissimos reiciendis quos cumque aspernatur quo
    voluptate qui laborum?`,
  },
  {
    id: 3,
    question: `Is Enter App to use?`,
    answer: `  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
    Suscipit distinctio eaque amet delectus fugit nostrum aut
    debitis corrupti culpa. Asperiores eum dignissimos
    reiciendis quos cumque aspernatur quo voluptate qui
    laborum? Lorem ipsum dolor sit, amet consectetur
    adipisicing elit. Suscipit distinctio eaque amet delectus
    fugit nostrum aut debitis corrupti culpa. Asperiores eum
    dignissimos reiciendis quos cumque aspernatur quo
    voluptate qui laborum?`,
  },
];
